import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import ImageControl from "../../common/ImageControl";
import Text from "../../common/Text";
import { saveJobStat } from "../../../states/actions/fetchDashboard";
import { useSelector, useDispatch } from "react-redux";
import {
  jobProgressColor,
  makeSalaryString,
  doFirstUpperRestLower,
  timeAgo,
  timeAgoShort,
} from "../../../helpers/helpers";
import * as paths from "../../../constants/paths";

export default function JobBlock({
  data,
  admin,
  job,
  saveJob,
  isJobSaving,
  handleJobApplyPopup,
  handleShowSigninPopup,
  showSigninPopup,
  openTooltipJobId,
  setOpenTooltipJobId,
  is_global_val = null,
  // icon,
  // title,
  // company,
  // location,
  // salary,
  // description,
  // tags = [],
  // duration,
  // postedAgo,
}) {
  const [bookmarked, setBookmarked] = useState(job.saved);
  useEffect(() => {
    setBookmarked(job.saved);
  }, [job.saved]);

  const authToken = useSelector((state) => state.fetchSignin.authToken);
  const dispatch = useDispatch();
  const isStatUpdating = useSelector(
    (state) => state.fetchDashboard.isStatUpdating
  );
  const [open, setOpen] = useState(null);
  const ref = useRef();

  //   useEffect(() => {
  //     const close = (e) => !ref.current.contains(e.target) && setOpen(null);
  //     document.addEventListener("mousedown", close);
  //     return () => document.removeEventListener("mousedown", close);
  //   }, []);
  const isTooltipOpen = openTooltipJobId === job.id;

  const toggle = (type) => setOpen(open === type ? null : type);
  const tooltipRef = useRef(null);
  const handleCompanyClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenTooltipJobId(isTooltipOpen ? null : job.id);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target) &&
        !event.target.closest(".company-link") // allow clicking the <a>
      ) {
        setOpenTooltipJobId(null);
      }
    };

    if (isTooltipOpen) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isTooltipOpen]);
  // const handleClick = (e) => {
  //   e.preventDefault();
  //   setShowTooltip((prev) => !prev);
  // };
  const tooltip =
    "A job is labelled as ‘definitely sponsor' if the job description clearly states that the role is eligible for visa sponsorship or if the company has a policy of sponsoring visas for all its roles.";
  const handleSaveJob = (id) => {
    if (job.saved) return;
    saveJob({ id: id });
    setBookmarked((prev) => !prev);
  };
  const handleJobStatUpdate = (formData) => {
    dispatch(saveJobStat(formData));
  };
  return (
    <>
      {job && (
        <div className="job_block">
          <div className="icon">
            {job.image == "" || job.image == null ? (
              <img
                src={paths.SITE_BASE_URL + "/images/no-image.svg"}
                alt="no image found"
              />
            ) : (
              <ImageControl src={job.image} folder="companies" isThumb={true} />
            )}
            {/* <img src={icon} alt="Job Icon" /> */}
          </div>
          <div className="text">
            <div className="heading">
              <Link
                to="#"
                onClick={() => handleJobApplyPopup(job)}
                style={{ cursor: "pointer" }}
              >
                {job.title}
              </Link>
            </div>
            <ul className="mini_list">
              <li>
                <img
                  src={
                    paths.SITE_BASE_URL + "/images/icon_mini_building.png"
                  }
                  alt="Company"
                />
                <span className="info">
                  <strong>{job.company_name}</strong>
                  <div className="infoIn">
                    {Number(job.computed_cos_total) > 0 ? (
                      <>
                        Based on Home Office data, {job.company_name} sponsored{" "}
                        {Number(job.computed_cos_total).toLocaleString()} Skilled
                        Worker visas in 2025.
                      </>
                    ) : (
                      <>
                        {job.company_name} issued fewer than 5 Skilled Worker
                        visas in 2025. The Home Office does not publish counts
                        below five.
                      </>
                    )}
                  </div>
                </span>
              </li>
              <li>
                <img
                  src={
                    paths.SITE_BASE_URL + "/images/icon_mini_map_marker.png"
                  }
                  alt="Location"
                />
                <span>{job.city}</span>
              </li>
              <li>
                {/* <img src="/images/icon_mini_wallet.png" alt="Salary" /> */}
                <img
                  // className="sm_icon_pound"
                  src={paths.SITE_BASE_URL + "/images/pound1.png"}
                  alt="Salary"
                />
                <span>
                  {makeSalaryString(
                    job.min_salary,
                    job.max_salary,
                    doFirstUpperRestLower(job.salary_interval)
                  )}
                </span>
              </li>
            </ul>
            <p>{job.description}</p>
            {/* <p>
              Drive product adoption and growth through strategic marketing
              initiatives. Lead campaigns, analyze metrics, and collaborate with
              cross-functional teams.
            </p> */}

            <div ref={ref} className="tooltip-wrapper-flex">
              {job.is_promoted === "1" && (
                <div className="tooltip-wrapper">
                  <span className="featured_job_new">Promoted</span>
                </div>
              )}

              {job.likely_to_sponsor === "yes" && (
                <div className={`tooltip-wrapper ${open && "open"}`}>
                  <Link
                    to=""
                    className="featured_job_new3"
                    onClick={(e) => (e.preventDefault(), toggle("likely"))}
                  >
                    {data.content.likely_sponsor_label}
                  </Link>
                  {open === "likely" && (
                    <div className="globals">
                      <p className="globals_info">
                        {data.content.likely_sponsor_desc}
                      </p>
                    </div>
                  )}
                </div>
              )}

              {job.definitely_sponsored === "yes" && (
                <div className={`tooltip-wrapper ${open && "open"}`}>
                  <Link
                    to=""
                    className="featured_job_new2"
                    onClick={(e) => (e.preventDefault(), toggle("definitely"))}
                  >
                    {data.content.definitely_sponsor_label}
                  </Link>
                  {open === "definitely" && (
                    <div className="globals">
                      <p className="globals_info">
                        {data.content.definitely_sponsor_desc}
                      </p>
                    </div>
                  )}
                </div>
              )}

              {job.new_entrant === "yes" && (
                <div className={`tooltip-wrapper ${open && "open"}`}>
                  <Link
                    to=""
                    className="featured_job_new4"
                    onClick={(e) => (e.preventDefault(), toggle("new"))}
                  >
                    {data.content.new_entry_label}
                  </Link>
                  {open === "new" && (
                    <div className="globals">
                      <p className="globals_info">
                        {data.content.new_entry_desc}
                      </p>
                    </div>
                  )}
                </div>
              )}

              {job.student_graduate === "yes" && (
                <div className={`tooltip-wrapper ${open && "open"}`}>
                  <Link
                    to=""
                    className="featured_job_new5"
                    onClick={(e) => (e.preventDefault(), toggle("student"))}
                  >
                    {data.content.student_label}
                  </Link>
                  {open === "student" && (
                    <div className="globals">
                      <p className="globals_info">
                        {data.content.student_desc}
                      </p>
                    </div>
                  )}
                </div>
              )}
            </div>
            {/* <div className="tag_list">

              {duration && (
                <span
                  className={`duration ${
                    duration.toLowerCase() !== "full-time" ? "sponsorship" : ""
                  }`}
                >
                  {duration}
                </span>
              )}
              {Array.isArray(tags) &&
                tags.map((tag, index) => <span key={index}>{tag}</span>)}
            </div> */}
          </div>
          <div className="book">
            <button
              type="button"
              className={`bookmark ${bookmarked ? "bookmarked" : ""}`}
              onClick={
                authToken ? () => handleSaveJob(job.id) : handleShowSigninPopup
              }
              disabled={isJobSaving}
            >
              <img
                src={
                  bookmarked
                    ? paths.SITE_BASE_URL +
                      "/images/icon_mini_bookmark_fill.png"
                    : paths.SITE_BASE_URL + "/images/icon_mini_bookmark.png"
                }
                alt="Bookmark"
              />
            </button>
            {/* <div className="ago">{timeAgoShort(job.created_date)}</div> */}

            {/* <button
              type="button"
              className={`${bookmarked ? "bookmarked" : ""}  bookmark`}
              onClick={() => setBookmarked(!bookmarked)}
            >
              <img
                src={
                  bookmarked
                    ? "/images/icon_mini_bookmark_fill.png"
                    : "/images/icon_mini_bookmark.png"
                }
                alt="Bookmark"
              />
            </button> */}
          </div>
        </div>
      )}
    </>
  );
}
